const getGiphyProxyUrl = (path, getOverride) => {
  if (getOverride) {
    return getOverride(path);
  }
  if (typeof window === "undefined")
    return void 0;
  return `${window.location.origin}/_serverless/ricos-giphy-proxy/${path}`;
};

export { getGiphyProxyUrl };
//# sourceMappingURL=getGiphyProxyUrl.js.map
